<template>
<div class="container has-text-centered">
	<p class="title">
		ABOUT PAGE
	</p>
	<p class="subtitle">
		Subtitle
	</p>
</div>
</template>
